import { Link } from "react-router-dom"

const Button =()=>{

    return(
        <div className="mt-20">
        <Link to="vulnerablepeople" className="z-10 mr-6 inline-flex h-12 items-center justify-center rounded bg-cyan-900 px-6 font-medium tracking-wide text-white shadow-md outline-none transition duration-200 hover:bg-yellow-600 focus:ring">Vulnerable People</Link>
        </div>
    )
}
export default Button;